
import { Link } from 'react-router-dom';
import { PageMeta } from '../../components/shared/PageMeta';
import { LegalPageLayout, LegalSection } from '../../components/feature/LegalPageLayout';
import { LEGAL_LAST_UPDATED } from '../../content/legalDates';

export default function CookiesPage() {
  return (
    <LegalPageLayout title="Cookie Policy" lastUpdated={LEGAL_LAST_UPDATED.cookies}>
      <PageMeta path="/cookies" />
      <LegalSection title="The short answer">
        <p>
          This site uses no cookies, no analytics, and no advertising or marketing trackers
          of any kind. Nothing is stored in your browser when you visit driscop.co.uk, and no
          data about your visit is collected unless you choose to submit a form.
        </p>
      </LegalSection>

      <LegalSection title="What a cookie is">
        <p>
          A cookie is a small file a website can ask your browser to store, typically used to
          remember who you are between page loads, measure traffic, or target advertising. We
          don't use any of these on this site.
        </p>
      </LegalSection>

      <LegalSection title="What we don't use">
        <ul className="list-disc pl-6 space-y-2">
          <li>No analytics or traffic-measurement cookies;</li>
          <li>No advertising or retargeting pixels;</li>
          <li>No social media tracking scripts;</li>
          <li>No data stored in your browser's local storage.</li>
        </ul>
        <p>
          Information you submit through a form on this site is sent directly to us when
          you press submit. It is not linked to anything stored in your browser, because
          nothing is stored there. See our{' '}
          <Link to="/privacy" className="text-blue-400 hover:text-blue-300">
            Privacy Policy
          </Link>{' '}
          for how that information is used.
        </p>
      </LegalSection>

      <LegalSection title="If this changes">
        <p>
          If we ever introduce analytics or any other non-essential cookie, we will update this
          page first and, where required under the Privacy and Electronic Communications
          Regulations (PECR), ask for your consent before setting anything in your browser.
        </p>
      </LegalSection>

      <LegalSection title="Questions">
        <p>
          If you have any questions about this policy, email us at{' '}
          <a href="mailto:hello@driscop.co.uk" className="text-blue-400 hover:text-blue-300">
            hello@driscop.co.uk
          </a>
          .
        </p>
      </LegalSection>
    </LegalPageLayout>
  );
}
